var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "nav-bar" }, [
    _c("div", { staticClass: "left-button" }, [
      _c(
        "button",
        {
          staticClass: "button-com",
          on: {
            click: function ($event) {
              return _vm.handleScroll(240)
            },
          },
        },
        [_vm._v("＜")]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "scrollOuter",
        staticClass: "scroll-outer",
        on: { DOMMouseScroll: _vm.handlescroll, mousewheel: _vm.handlescroll },
      },
      [
        _c(
          "div",
          {
            ref: "scrollBody",
            staticClass: "scroll-body",
            style: { left: _vm.tagBodyLeft + "px" },
          },
          _vm._l(_vm.tabList, function (item) {
            return _c(
              "div",
              {
                key: item.name,
                ref: "tagsPageOpened",
                refInFor: true,
                staticClass: "tag-ct",
                class: { current: _vm.isCurrentTag(item) },
                on: {
                  click: function ($event) {
                    return _vm.onTagClick(item)
                  },
                },
              },
              [
                _c("span", { staticClass: "dot" }),
                _vm._v(" "),
                _c("span", { staticStyle: { "font-size": "14px" } }, [
                  _vm._v(_vm._s(item.label)),
                ]),
                _vm._v(" "),
                item.closable
                  ? _c(
                      "i",
                      {
                        staticClass: "close",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.onCloseClick(item)
                          },
                        },
                      },
                      [_vm._v("×")]
                    )
                  : _vm._e(),
              ]
            )
          }),
          0
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "right-button" }, [
      _c(
        "button",
        {
          staticClass: "button-com",
          on: {
            click: function ($event) {
              return _vm.handleScroll(-240)
            },
          },
        },
        [_vm._v("＞")]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "contextmenu" },
      [
        _c(
          "el-dropdown",
          { staticClass: "dropDownBtn" },
          [
            _c("i", { staticClass: "el-icon-circle-close" }),
            _vm._v(" "),
            _c(
              "el-dropdown-menu",
              { attrs: { slot: "dropdown" }, slot: "dropdown" },
              [
                _c(
                  "el-dropdown-item",
                  {
                    attrs: { disabled: !_vm.tabList.length },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.handleTagsOption("all")
                      },
                    },
                  },
                  [_vm._v("关闭所有")]
                ),
                _vm._v(" "),
                _c(
                  "el-dropdown-item",
                  {
                    attrs: { divided: "", disabled: _vm.tabList.length <= 1 },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.handleTagsOption("other")
                      },
                    },
                  },
                  [_vm._v("关闭其他")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }